import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { loginUser } from "./queries";
import { adminBaseUrl } from "../routes";
import { clearAuth, setAuth } from "./adminSlice";

const adminAuthApi = createApi({
  reducerPath: "admin-auth",
  baseQuery: fetchBaseQuery({
    baseUrl: adminBaseUrl,
  }),
  endpoints: (builder) => ({
    //login admin
    login: builder.mutation({
      providesTags: ["AdminLogin"],
      query: loginUser,
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const res = await queryFulfilled;
          if (res.data) {
            console.log(res.data.user);
            // localStorage.setItem("user", JSON.stringify(res.data.user));
            // localStorage.setItem("token", JSON.stringify(res.data.token));
            dispatch(setAuth(res.data));
          }
        } catch (err) {
          console.log(err?.error?.data?.error?.message);
        }
      },
    }),
  }),
});

//logout user
export const logoutUser = (dispatch) => {
  adminAuthApi.util.invalidateTags(["AdminLogin"]);
  dispatch(clearAuth());
};

export const {
  reducer: adminAuthReducer,
  reducerPath: adminAuthReducerPath,
  middleware: adminAuthMiddleware,
  useLoginMutation,
  endpoints: adminAuthEndpoints,
} = adminAuthApi;
